module.exports = __webpack_public_path__ + "img/line-ribbon02.87430b52.svg";